import React from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiIconButton from '@material-ui/core/IconButton';

import Logo from './Logo';

const useStyles = makeStyles(theme => (
  {
    logo: {
      fill : theme.palette.secondary.contrastText,
      [theme.breakpoints.down('sm')]: {
        width : '30px',
        height : '30px'
      },
      [theme.breakpoints.up('sm')]: {
        width : '40px',
        height : '40px'
      },
    },
  }));

export default React.forwardRef(function LogoButton(props, ref)
{
  const classes = useStyles();
  return (
    <MuiIconButton ref={ref} {...props}>
      <Logo color="inherit" className={classes.logo}/>
    </MuiIconButton>
  );
});